
import { NavLink } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import {
  Users,
  Settings,
  FileText,
  BarChart3,
  Upload,
  Bot,
  Database,
  LayoutDashboard,
  Building2,
  ListChecks,
  Calendar,
  HelpCircle,
  Contact2,
  Activity,
  Wallet,
  MessageSquare,
  Image,
  Video,
  File,
  ShieldCheck,
  Mail,
  Bell,
  Archive,
  Trash2,
  Plus,
  Check,
  X,
  ChevronDown,
  ChevronUp,
  Copy,
  Edit,
  Eye,
  EyeOff,
  Download,
  Share2,
  Move,
  RotateCw,
  ZoomIn,
  ZoomOut,
  Code,
  Terminal,
  GitPullRequest,
  GitCommit,
  GitBranch,
  GitMerge,
  Package,
  Package2,
  Box,
  ShoppingCart,
  CreditCard,
  Coins,
  Percent,
  Gift,
  Heart,
  Star,
  Flag,
  Award,
  Trophy,
  Puzzle,
  Lightbulb,
  Link,
  Link2,
  Globe,
  MapPin,
  Phone,
  Printer,
  Keyboard,
  MousePointer,
  Monitor,
  Server,
  Cpu,
  Disc,
  Headphones,
  Camera,
  CameraOff,
  Mic,
  MicOff,
  Volume1,
  Volume2,
  VolumeX,
  Clock,
  AlarmClock,
  Timer,
  History,
  TrendingUp,
  TrendingDown,
  Maximize2,
  Minimize2,
  ExternalLink,
  Github,
  Dribbble,
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  Youtube,
  Rss,
  Wifi,
  Bluetooth,
  BatteryCharging,
  BatteryFull,
  BatteryMedium,
  BatteryLow,
  Signal,
  Lock,
  Unlock,
  Key,
  Tag,
  Bookmark,
  AtSign,
  Hash,
  Slash,
  Asterisk,
  PlusCircle,
  MinusCircle,
  CheckCircle,
  XCircle,
  AlertCircle,
  AlertTriangle,
  Info,
  Search,
  Menu,
  GripVertical,
  GripHorizontal,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  ChevronsDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ArrowUpDown,
  ArrowLeftRight,
  Repeat,
  Shuffle,
  SkipBack,
  SkipForward,
  Play,
  Pause,
  Volume,
  Power,
  LogOut,
  LogIn,
  RefreshCw,
  RotateCcw,
  Layout,
  LayoutList,
  LayoutGrid,
  LayoutDashboard as LayoutDashboardIcon,
  LayoutTemplate,
  LayoutPanelLeft,
  LayoutPanelTop,
  type LucideIcon
} from 'lucide-react';

// Define sidebar navigation item type
interface SidebarNavItem {
  title: string;
  icon: LucideIcon;
  path: string;
  children?: SidebarNavItem[];
}

// Admin sidebar component
const AdminSidebar = () => {
  // Define admin navigation items
  const adminNavItems: SidebarNavItem[] = [
    {
      title: 'Dashboard',
      icon: LayoutDashboard,
      path: '/admin',
    },
    {
      title: 'User Management',
      icon: Users,
      path: '/admin/users',
    },
    {
      title: 'System Settings',
      icon: Settings,
      path: '/admin/settings',
    },
    {
      title: 'Content Manager',
      icon: FileText,
      path: '/admin/content',
    },
    {
      title: 'Analytics',
      icon: BarChart3,
      path: '/admin/analytics',
    },
    {
      title: 'AI Assistants',
      icon: Bot,
      path: '/admin-ai-helper',
    },
    {
      title: 'AI Knowledge',
      icon: Database,
      path: '/ai-file-settings',
    },
  ];

  return (
    <div className="h-full py-4 flex flex-col bg-background border-r">
      <div className="px-3 py-2">
        <h2 className="mb-2 px-4 text-lg font-semibold tracking-tight text-primary">
          Admin Panel
        </h2>
      </div>
      <ScrollArea className="flex-1 px-3">
        <nav className="grid gap-1 px-2">
          {adminNavItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium ${
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                }`
              }
            >
              <item.icon className="h-5 w-5" />
              {item.title}
            </NavLink>
          ))}
        </nav>
      </ScrollArea>
      <div className="p-4 border-t">
        <NavLink 
          to="/dashboard" 
          className="flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-primary"
        >
          <ArrowLeft className="h-4 w-4" />
          Return to Dashboard
        </NavLink>
      </div>
    </div>
  );
};

export default AdminSidebar;
